export enum GroupOrderStatus {
  OPEN = 0,
  CLOSED = 1,
  AWAITING_PAYMENTS = 2,
  SUBMITTING = 3,
  SUBMITTED = 4,
  CANCELLED = 5,
}

export enum PaymentMode {
  ORGANIZER_PAYS_ALL = 0,
  EACH_PAYS_OWN = 1,
}

export enum ParticipantPaymentStatus {
  PENDING = 0,
  IN_PROGRESS = 1,
  PAID = 2,
  REMOVED = 3,
}

export interface ParticipantItem {
  menuItemId: string;
  name: string;
  quantity: number;
  price: number;
  configuredMenuItemOrderData: any;
}

export interface Participant {
  participantId: string;
  name: string;
  phone?: string;
  userId?: string;
  items: ParticipantItem[];
  subtotal: number;
  paymentStatus: ParticipantPaymentStatus;
  joinedAt?: string;
}

export interface GroupOrderData {
  groupOrderId: string;
  joinCode: string;
  shareableLink: string;
  qrCodeBase64?: string;
  organizerId: string;
  organizerName: string;
  businessId: string;
  branchId: string;
  servingOptionType: number;
  paymentMode: PaymentMode;
  status: GroupOrderStatus;
  participants: Participant[];
  lastModified?: string;
  orderId?: string;
}

export interface ActivityEvent {
  id: string;
  type: "joined" | "items_changed" | "items_cleared" | "removed" | "left";
  participantName: string;
  participantId: string;
  detail?: string;
  timestamp: number;
}

export interface ParticipantIdentity {
  color: string;
  avatar: string;
}

export interface GroupOrderState {
  active: boolean;
  isOrganizer: boolean;
  groupOrderId: string | null;
  joinCode: string | null;
  shareableLink: string | null;
  qrCodeBase64: string | null;
  participantId: string | null;
  participantName: string | null;
  paymentMode: PaymentMode;
  groupOrder: GroupOrderData | null;
  localItems: any[];
  lastModified: string | null;
  activityEvents: ActivityEvent[];
  participantIdentities: Record<string, ParticipantIdentity>;
  creating: boolean;
  createError: string | null;
  joining: boolean;
  joinError: string | null;
  syncing: boolean;
  syncError: string | null;
  closing: boolean;
  closeError: string | null;
  cancelling: boolean;
  cancelError: string | null;
  polling: boolean;
  paymentInProgress: boolean;
  paymentError: string | null;
}
